(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/proxy.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/proxy.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }

const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const getLogger = svs.isServer ? trinidad.logger : svs.core.log.getLogger;
const definedHandlers = svs.isServer ? require('./handlers/index.es6') : svs.components.lbUtils.apiProxy.handlers.index;
const {
  HTTP_METHOD,
  HTTP_METHODS
} = svs.isServer ? require('./constants.es6') : svs.components.lbUtils.apiProxy.constants;
let legacyFetch;
let cloudFetch;
if (!svs.isServer) {
  legacyFetch = trinidad.jupiterFetch.fetch;
  cloudFetch = trinidad.svsFetch.create();
} else {
  cloudFetch = async function cloudFetch(path) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const svsFetch = trinidad.svsFetch(options.req);
    return svsFetch(path, options);
  };
  legacyFetch = async function legacyFetch(path) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise((resolve, reject) => {
      const fetchOptions = {
        method: options.method || 'GET',
        path,
        req: options.req
      };
      trinidad.jupiter.call(fetchOptions, (err, data) => {
        if (err) {
          reject(data || err);
          return;
        }
        resolve({
          ok: true,
          json: async () => data
        });
      });
    });
  };
}
const logger = getLogger('lb-utils:api-proxy');

var _handlers = new WeakMap();
var _cloudTransport = new WeakMap();
var _legacyTransport = new WeakMap();
var _ApiProxy_brand = new WeakSet();
class ApiProxy {
  constructor() {
    let handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let {
      legacyTransport,
      cloudTransport
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classPrivateMethodInitSpec(this, _ApiProxy_brand);
    _classPrivateFieldInitSpec(this, _handlers, []);
    _classPrivateFieldInitSpec(this, _cloudTransport, void 0);
    _classPrivateFieldInitSpec(this, _legacyTransport, void 0);
    if (!Array.isArray(handlers)) {
      throw new TypeError('handlers should be an array');
    }
    if (legacyTransport && !(legacyTransport instanceof Function)) {
      throw new TypeError('legacyTransport should be a function that takes url and options and returns a promise');
    }
    if (cloudTransport && !(cloudTransport instanceof Function)) {
      throw new TypeError('cloudTransport should be a function that takes url and options and returns a promise');
    }
    _classPrivateFieldSet(_cloudTransport, this, cloudTransport !== null && cloudTransport !== void 0 ? cloudTransport : cloudFetch);
    _classPrivateFieldSet(_legacyTransport, this, legacyTransport !== null && legacyTransport !== void 0 ? legacyTransport : legacyFetch);
    _classPrivateFieldSet(_handlers, this, handlers);
  }

  get handlers() {
    return _classPrivateFieldGet(_handlers, this);
  }

  addHandlers(handlerOrHandlers) {
    if (Array.isArray(handlerOrHandlers)) {
      _classPrivateFieldGet(_handlers, this).push(...handlerOrHandlers);
    } else {
      _classPrivateFieldGet(_handlers, this).push(handlerOrHandlers);
    }
    return this;
  }

  removeHandler(handler) {
    const index = _classPrivateFieldGet(_handlers, this).indexOf(handler);
    if (index !== -1) {
      _classPrivateFieldGet(_handlers, this).splice(index, 1);
    } else {
      logger.warn('Attempted to remove a handler that does not exist in the proxy');
    }
  }

  async findHandler(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const upperMethod = String(options.method || 'GET').toUpperCase();
    for (let i = _classPrivateFieldGet(_handlers, this).length - 1; i >= 0; i--) {
      const handler = _classPrivateFieldGet(_handlers, this)[i];
      if (handler.method !== upperMethod) {
        continue;
      }

      const {
        matches,
        params
      } = await handler.match(url, options);
      if (matches) {
        return {
          handler,
          index: i,
          params
        };
      }
    }
    return undefined;
  }

  reset() {
    _classPrivateFieldSet(_handlers, this, []);
  }

  async test(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      method: HTTP_METHOD.GET
    };
    const found = await this.findHandler(url, options);
    return found;
  }
  async fetch(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      method: HTTP_METHOD.GET
    };
    const method = _assertClassBrand(_ApiProxy_brand, this, _resolveMethod).call(this, options.method);
    let route = 'legacy';
    let matchedHandler = null;
    let params = null;
    try {
      const found = await this.findHandler(url, _objectSpread(_objectSpread({}, options), {}, {
        method
      }));
      if (!found) {
        logger.debug("No matching handler found for ".concat(method, " ").concat(url, ", forwarding to legacy transport"));
        const response = await _classPrivateFieldGet(_legacyTransport, this).call(this, url, _objectSpread(_objectSpread({}, options), {}, {
          method
        }));
        const data = await response.json();
        if (!response.ok) {
          var _data$error;
          logger.error("Legacy request failed with status ".concat(response.status, ": ").concat(JSON.stringify(data)));
          const error = new Error("HTTP ".concat(response.status));
          error.status = response.status;
          error.details = (_data$error = data.error) !== null && _data$error !== void 0 ? _data$error : data;
          throw error;
        }
        return data;
      }
      route = 'cloud';
      matchedHandler = found.handler;
      params = found.params;
      const {
        handler,
        index
      } = found;
      if (handler.options && handler.options.once) {
        _classPrivateFieldGet(_handlers, this).splice(index, 1);
      }
      return await handler.execute({
        url,
        params,
        options: _objectSpread(_objectSpread({}, options), {}, {
          method
        }),
        transport: _classPrivateFieldGet(_cloudTransport, this)
      });
    } catch (error) {
      var _matchedHandler;
      logger.error('ApiProxy.fetch failed', error, {
        method,
        url,
        route,
        predicate: (_matchedHandler = matchedHandler) === null || _matchedHandler === void 0 ? void 0 : _matchedHandler.predicate,
        params,
        errorMessage: error.message
      });
      throw error;
    }
  }

  static create() {
    let handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      method: HTTP_METHOD.GET
    };
    const combinedHandlers = [...definedHandlers, ...handlers];
    const combinedOptions = _objectSpread({}, options);
    return new ApiProxy(combinedHandlers, combinedOptions);
  }
}
function _resolveMethod(method) {
  if (!method) {
    return HTTP_METHOD.GET;
  }
  if (!HTTP_METHODS.includes(method.toUpperCase())) {
    throw new TypeError("Invalid HTTP method: ".concat(method));
  }
  return method.toUpperCase();
}
if (svs.isServer) {
  module.exports = ApiProxy;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.ApiProxy', ApiProxy);
}

 })(window);